import { Box } from "@mui/material";
import type { ReactNode } from "react";
import type { SxProps, Theme } from "@mui/material/styles";

import { DashMobileSectionHeader } from "@/pages/home/components/PatientDash/components/DashMobileSectionHeader";

interface EhrSummaryMobileSectionProps {
  title: string;
  subtitle?: string;
  action?: ReactNode;
  children: ReactNode;
  sx?: SxProps<Theme>;
}

/**
 * Seção do sumário mobile — mesmo ritmo do DashMobileSection,
 * com container neutro para separar visualmente cada bloco clínico.
 */
export function EhrSummaryMobileSection({
  title,
  subtitle,
  action,
  children,
  sx,
}: EhrSummaryMobileSectionProps) {
  return (
    <Box
      sx={{
        width: "100%",
        borderRadius: 2.5,
        border: "1px solid",
        borderColor: "divider",
        bgcolor: "background.paper",
        px: 1.25,
        py: 1.25,
        boxShadow: "0 1px 8px rgba(15, 23, 42, 0.04)",
        ...sx,
      }}
    >
      <DashMobileSectionHeader
        title={title}
        subtitle={subtitle}
        action={action}
      />
      {children}
    </Box>
  );
}
